module.exports = __webpack_public_path__ + "img/logo_home.c5068d83.png";